import React from 'react';
import ViewDocument from '../components/ViewDocument';

export default function ViewPurchaseOrder() {
  return (
    <ViewDocument
      apiPath="purchase-orders"
      numberField="po_number"
      editPath="/edit-purchase-order"
      listPath="/purchase-orders"
      docLabel="Purchase Order"
    />
  );
}
